import Vue from "vue";
import VueRouter from "vue-router";
import LoginPage from "../pages/login-page/login-page.vue";
import SignupPage from "../pages/signup-page/signup-page.vue";
import ForgotPasswordPage from "../pages/forgot-password/forgot-password-page.vue";
import EventsPage from "../pages/events/events-page.vue";
import PeoplePage from "../pages/people/people-page.vue";
import PeopleEventsPage from "../pages/people/people-invite-events-page.vue";
import EventTaskAddPage from "../pages/events/tasks/tasks-add-page.vue";
import TasksPage from "../pages/tasks/tasks-page.vue";
import PrivacyPolicyPage from "../pages/privacy-policy/privacy-policy-page.vue";
import SupportPage from "../pages/support/support.vue";
import AboutPage from "../pages/about/about.vue";
import ChangePasswordPage from "../pages/settings/change-password.vue";
import SettingsPage from "../pages/settings/settings.vue";
import AccountPage from "../pages/settings/account.vue";
import ContactPage from "../pages/settings/contact.vue";
import SubscriptionPage from "../pages/settings/subscription.vue";
import ErrorSubscriptionPage from "../pages/settings/error-payment-page.vue";
import SubscriptionSuccessPage from "../pages/settings/subscription-success.vue";
import PaymentMethodUpdatedSuccess from "../pages/settings/payment-method-edited-success.vue";
import PaymentMethodUpdatedFailure from "../pages/settings/payment-method-edited-failure.vue";
import UnsubscriptionSuccessPage from "../pages/settings/unsubscription-success.vue";
import EventPage from "../pages/events/event-page.vue";
import EventGuestsPage from "../pages/events/guests/guest-page.vue";
import EventGuestAddPage from "../pages/events/guests/guests-add-page.vue";
import EventsAddPage from "../pages/events/events-add-page.vue";
import PeopleAddPage from "../pages/people/people-add-page.vue";
import PeopleEditPage from "../pages/people/people-edit-page.vue";
import GeneralErrorPage from "../pages/error-general-page.vue";
import ConnectionLostErrorPage from "../pages/error-connection-lost-page.vue";
import TasksAddPage from "../pages/tasks/tasks-add-page.vue";
import Layout from "../pages/layout.vue";
import EventLayout from "../pages/event-layout.vue";
import EventTaskLayout from "../pages/event-task-layout.vue";
import PeopleLayout from "../pages/people-layout.vue";
import store from "./../store";

Vue.use(VueRouter);
let routes = [
    {
        path: "/app",
        name: "landing",
        component: Layout,
        redirect: { name: "login" },
        children: [
            {
                path: "/signup",
                name: "signup",
                component: SignupPage,
                meta: {
                    title: "Sign up"
                }
            },
            {
                path: "/login",
                name: "login",
                component: LoginPage,
                beforeEnter: (to, from, next) => {
                    if (store.state.is_logged_in) {
                        next({ name: "events" });
                    } else {
                        next();
                    }
                },
                meta: {
                    title: "Login"
                }
            },
            {
                path: "/forgot-password",
                name: "forgot-password",
                component: ForgotPasswordPage,
                meta: {
                    title: "Log in"
                }
            },
            {
                path: "/events",
                name: "events",
                component: EventsPage,
                meta: {
                    title: "Events",
                    addNewLink: "/app/events/add",
                    requires_auth: true
                }
            },
            {
                path: "/people",
                name: "people",
                component: PeoplePage,
                meta: {
                    title: "People",
                    addNewLink: "/app/people/add",
                    requires_auth: true
                }
            },

            {
                path: "/events/edit/:id",
                name: "event-edit",
                component: EventsAddPage,
                meta: {
                    title: "Edit event",
                    isAddView: true,
                    action: "save_new_event",
                    requires_auth: true
                }
            },
            {
                path: "/error",
                name: "error",
                component: GeneralErrorPage,
                meta: {
                    title: "Error"
                }
            },
            {
                path: "/privacy-policy",
                name: "privacy",
                component: PrivacyPolicyPage,
                meta: {
                    title: "Terms & Privacy policy"
                }
            },
            {
                path: "/settings/account",
                name: "account",
                component: AccountPage,
                meta: {
                    back_link: "/settings",
                    title: "Account",
                    isAddView: true
                }
            },
            {
                path: "/settings/account/payment-update-success",
                name: "account",
                component: PaymentMethodUpdatedSuccess,
                meta: {
                    back_link: "/settings/account",
                    title: "Account",
                    isAddView: true
                }
            },
            {
                path: "/settings/account/payment-update-fail",
                name: "account",
                component: PaymentMethodUpdatedFailure,
                meta: {
                    back_link: "/settings/account",
                    title: "Account",
                    isAddView: true
                }
            },
            {
                path: "/settings/contact",
                name: "account",
                component: ContactPage,
                meta: {
                    back_link: "/settings",
                    title: "Contact info",
                    isAddView: true
                }
            },
            {
                path: "/settings/subscription",
                name: "subscription",
                component: SubscriptionPage,
                redirect: { name: "settings" },
                meta: {
                    back_link: "/settings",
                    title: "Subscription",
                    isAddView: true
                }
            },
            {
                path: "/settings/subscription/success",
                name: "subscription-success",
                component: SubscriptionSuccessPage,
                meta: {
                    back_link: "/settings",
                    title: "Account",
                    isAddView: true
                }
            },
            {
                path: "/settings/subscription/unsubscribe",
                name: "unsubscribe",
                component: UnsubscriptionSuccessPage,
                meta: {
                    back_link: "/settings",
                    title: "Account",
                    isAddView: true
                }
            },
            {
                path: "/settings/subscription/error",
                name: "error",
                component: ErrorSubscriptionPage,
                meta: {
                    back_link: "/settings/subscription",
                    title: "Error",
                    isAddView: true
                }
            },
            {
                path: "/settings/change-password",
                name: "change-password",
                component: ChangePasswordPage,
                meta: {
                    back_link: "/settings",
                    title: "Change password",
                    isAddView: true
                }
            },
            {
                path: "/about",
                name: "about",
                component: AboutPage,
                meta: {
                    title: "About"
                }
            },
            {
                path: "/settings",
                name: "settings",
                component: SettingsPage,
                meta: {
                    title: "Settings"
                }
            },
            {
                path: "/support",
                name: "support",
                component: SupportPage,
                meta: {
                    title: "Support"
                }
            },
            {
                path: "/error/connection-lost",
                name: "connection-lost",
                component: ConnectionLostErrorPage,
                meta: {
                    title: "Error"
                }
            },
            {
                path: "/tasks",
                name: "tasks",
                component: TasksPage,
                meta: {
                    title: "Tasks",
                    addNewLink: "/app/tasks/add",
                    requires_auth: true
                }
            },
            {
                path: "/events/add",
                name: "events-add",
                component: EventsAddPage,
                meta: {
                    back_link: "/events",
                    title: "Add event",
                    isAddView: true,
                    action: "save_new_event",
                    requires_auth: true
                }
            },
            {
                path: "/people/add",
                name: "people-add",
                component: PeopleAddPage,
                meta: {
                    back_link: "/people",
                    title: "Add person",
                    isAddView: true,
                    action: "save_new_person",
                    requires_auth: true
                }
            },
            {
                path: "/tasks/add",
                name: "tasks-add",
                component: TasksAddPage,
                meta: {
                    title: "Add task",
                    isAddView: true,
                    action: "save_task",
                    requires_auth: true
                }
            }
        ]
    },
    {
        path: "/events/",
        name: "events-layout",
        component: EventLayout,
        children: [
            {
                path: "/events/:id",
                name: "event",
                component: EventPage,
                meta: {
                    title: "Event",
                    requires_auth: true
                }
            },
            {
                path: "/events/:id/tasks/add",
                name: "event-tasks-add",
                component: EventTaskAddPage,
                meta: {
                    title: "Add task",
                    isAddView: true,
                    action: "saveTask",
                    requires_auth: true
                }
            },
            {
                path: "/events/:id/guests/add",
                name: "event-guests-add",
                component: EventGuestAddPage,
                meta: {
                    title: "Add Guest",
                    isAddView: true,
                    action: "saveGuests",
                    actionBtnLabel: "+ Add selected",
                    requires_auth: true
                }
            },
            {
                path: "/events/:id/guests",
                name: "event-guests",
                component: EventGuestsPage,
                meta: {
                    title: "Guests",
                    action: "saveGuest",
                    requires_auth: true
                }
            }
        ]
    },
    {
        path: "/event-tasks/",
        name: "tasks-layout",
        component: EventTaskLayout,
        children: [
            {
                path: "/events/:id/tasks/:task_id",
                name: "event-tasks-edit",
                component: EventTaskAddPage,
                meta: {
                    title: "Edit task",
                    isAddView: true,
                    action: "saveTask",
                    requires_auth: true
                }
            }
        ]
    },
    {
        path: "/people/",
        name: "people-layout",
        component: PeopleLayout,
        children: [
            {
                path: "/people/:id",
                name: "person-edit",
                component: PeopleEditPage,
                meta: {
                    title: "Edit person",
                    isAddView: true,
                    action: "save_person",
                    requires_auth: true
                }
            },
            {
                path: "/people/:id/events",
                name: "person-events",
                component: PeopleEventsPage,
                meta: {
                    title: "Invite",
                    isAddView: false,
                    action: "save_invitations",
                    requires_auth: true
                }
            }
        ]
    }
];

let router = new VueRouter({
    mode: "history",
    base: "/app",
    routes
});

export default router;

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requires_auth)) {
        if (!store.state.is_logged_in) {
            next({ name: "login" });
        } else {
            next();
        }
    } else {
        next();
    }
});
